var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrgzInactive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9615 6.11536H3.03846C2.18879 6.11536 1.5 6.80415 1.5 7.65382V18.423C1.5 19.2727 2.18879 19.9615 3.03846 19.9615H19.9615C20.8112 19.9615 21.5 19.2727 21.5 18.423V7.65382C21.5 6.80415 20.8112 6.11536 19.9615 6.11536Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.5 12.2692H21.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.5 10.7308V13.8077",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.1155 6.11538C16.1155 4.89131 15.6293 3.71737 14.7637 2.85182C13.8982 1.98626 12.7242 1.5 11.5002 1.5V1.5C10.2761 1.5 9.10213 1.98626 8.23658 2.85182C7.37103 3.71737 6.88477 4.89131 6.88477 6.11538",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrgzInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/orgz_inactive.a3cdcc464d0aa03c6b522af647f4b234.svg";